import {
 
  GroupAddOutlined,

  MoreTime,
  OpenInNew,
} from "@mui/icons-material";
import { PlannerLayout } from "../../layouts";
import { Grid, Link, Paper, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const PlannerDashboard = () => {
  const provinciasData = [
    { provincia: "San José", estudiantes: 250 },
    { provincia: "Alajuela", estudiantes: 150 },
    { provincia: "Cartago", estudiantes: 100 },
    { provincia: "Heredia", estudiantes: 120 },
    { provincia: "Guanacaste", estudiantes: 80 },
    { provincia: "Puntarenas", estudiantes: 90 },
    { provincia: "Limón", estudiantes: 70 },
  ];

  return (
    <PlannerLayout title="Informacion general">
      <Grid container spacing={4} alignItems="center" mb={2} pt={2}>
        <Grid item xs={12}>
          <Typography
            sx={{ fontWeight: 500, fontSize: 40, }}
          >
            Bienvenido, usuario
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 400, fontSize: 14, }}
          >
            Comienza a explorar y descubre todas nuestras herramientas para
            garantizar el éxito de tus eventos
          </Typography>
        </Grid>

        <Grid item xs={12} sm={3.5}>
          <Paper
            elevation={6}
            sx={{
              padding: 4,
              borderRadius: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <OpenInNew sx={{ fontSize: 25 }} />
            <Link
              component={RouterLink}
              to="/ruta-a-tus-eventos"
              color={"text.primary"}
              style={{ textDecoration: "none" }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                Crea nuevos eventos
              </Typography>
            </Link>
            <Typography variant="body2" color="warning.main">
              Gestiona tus eventos de manera fácil y rápida
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={3.5}>
          <Paper
            elevation={6}
            sx={{
              padding: 4,
              borderRadius: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <GroupAddOutlined sx={{ fontSize: 25 }} />
            <Link
              component={RouterLink}
              to="/ruta-a-tus-eventos"
              color={"text.primary"}
              style={{ textDecoration: "none" }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                Visualiza los clientes
              </Typography>
            </Link>
            <Typography variant="body2" color="warning.main">
              Mira las personas que han comprado entradas
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={3.5}>
          <Paper
            elevation={6}
            sx={{
              padding: 4,
              borderRadius: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MoreTime sx={{ fontSize: 25 }} />
            <Link
              component={RouterLink}
              to="/ruta-a-tus-eventos"
              color={"text.primary"}
              style={{ textDecoration: "none" }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                Administra tu organización
              </Typography>
            </Link>
            <Typography variant="body2" color="warning.main">
              Administración de los datos de la empresa
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </PlannerLayout>
  );
};
